import AssaAbloyLogo from './assa_abloy_logo';

export default AssaAbloyLogo;
